
import { AppClaims } from './../models/AppClaims';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, Renderer2, AfterViewInit, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { GlobalsService } from '../services/globals.service';
import { BaseBus } from '../models/BaseBus';

import { DQOIService } from '../services/DQOI.service';
import { UntypedFormGroup } from '@angular/forms';
import { CommonFunctions } from '../static/common-functions';
import { DQOISearchEvent } from '../models/DQOISearchEvent';
import { SearchTarget } from '../enums/SearchTarget';
import { DQOIToolbarEvent } from '../models/DQOIToolbarEvent';
import { ToolbarEvent } from '../enums/ToolbarEvent';
import * as _ from 'lodash';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { DQOIReferenceData } from '../models/DQOIReferenceData';
import { GItem } from '../models/GItem';
import { SelectEvent, TabStripTabComponent, TabStripComponent } from '@progress/kendo-angular-layout';
import { BasePage } from '../models/BasePage';
import { MatExpansionPanel } from '@angular/material/expansion';
import { GeographyInfoBus } from '../models/GeographyInfoBus';
import { GeographyInfoComponent } from '../contact/geography-info/geography-info.component';
import { MessageType } from '../enums/MessageType';
import { DQOIItem } from '../models/DQOIItem';
import { DQOIMessage } from '../models/DQOIMessage';
import { BusinessObjectFactory } from '../models/BusinessObjectFactory';
import { v_LocationDetailBus } from '../models/v_LocationDetailBus';
import { DropDownFilterSettings, ComboBoxComponent, DropDownListComponent } from '@progress/kendo-angular-dropdowns';
import { Message } from '../models/message';
import { SaveMode } from '../enums/SaveMode';
import { CRUDActions } from '../enums/CRUDActions';
import { ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import { CommonValues } from '../static/CommonValues';
import { ConfirmOutput } from '../models/ConfirmOutput';
import { CPDialogResult } from '../enums/CPDialogResult';
import { DateFunctions } from '../static/date-functions';
import { MessageInfoDialogComponent } from '../components/message-info-dialog/message-info-dialog.component';
import { BaseMessageInfo } from '../models/BaseMessageInfo';
import { MessageInfoShow } from '../models/MessageInfoShow';
import { DbTable } from '../enums/DbTable';
import { WindowContents } from '../enums/windowContents';
import { DispatchData } from '../models/DispatchData';
import { DQOIParam } from '../models/DQOIParam';
import { MessageInfoType } from '../enums/MessageInfoType';
import { CommonParam } from '../models/CommonParam';
import { GGItem } from '../models/GGItem';
import { BaseService } from '../services/base.service';
import { CommonActions } from '../enums/CommonActions';
import { RefreshToken } from '../models/RefreshToken';
import { AppCategory } from '../enums/AppCategories';
import { SearchOperatingMode } from '../enums/SearchOperatingMode';
import { AppOperationCode } from '../enums/AppOperationCode';
import { GCItem } from '../models/GCItem';
import { Align } from "@progress/kendo-angular-popup";
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { ICPLoader } from '../decorators/cploader/cploader-decorator';
import { validateOverridables, EmptyOverridable } from '../decorators/overridable/base-method-override-decorator';
import { AfterHoursPoComponent } from '../../dispatches/after-hours-po/after-hours-po.component';

@Component({
    selector: '',
    template: '',
    standalone: false
})
export class BaseDQOIComponent<T extends BaseBus, S extends BaseService, A extends BaseBus, P extends BasePage<S>> implements OnInit, AfterViewInit, OnDestroy {
    internalCploader: ICPLoader = this as any;
    public popUp: boolean = false;
    appCode: string = null;
    subs_data: Subscription;
    public anchorAlign: Align = { horizontal: "right", vertical: "bottom" };
    public popupAlign: Align = { horizontal: "right", vertical: "top" };
    public virtual: any = {
        itemHeight: 28,
    };
    virtualizationSettings = CommonValues.virtualizationSettings;

    private _rights: AppClaims | null = null;

    /**
     * Using this getter can cause race conditions in code depending on how this is used.
     * While we have a user data  resolver in place to help, this still could cause issues.
     * If you need reliable data from the user object, use CmProAuthService.subscribeToLoginEvents and CmProAuthService.unsubscribeToLoginEvents in your component
     *
     * @readonly
     * @type {AppClaims}
     * @memberof BaseDQOIComponent
     */
    get rights(): AppClaims {
        return this._rights ?? this.globals.user?.appClaims ?? new AppClaims();
    }

    set rights(value: AppClaims) {
        this._rights = value;
    }

    renderer: Renderer2;
    constructor(public globals: GlobalsService, protected featureFlagService: FeatureFlagService, svc_dqoi: DQOIService, qry_rd: DQOIReferenceDataQuery) {
        this.svc_dqoi = svc_dqoi;
        this.qry_rd = qry_rd;

        this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe(() => {
            this.customReferenceData();
        });
        if (this.rights.DefaultEditMode) {
            this.edit();
        }
        this.svc_dqoi.message$.subscribe((msg: Message) => {
            if (msg != null) {
                if (msg.messageType === MessageType.dqoiPopup) {
                    this.svc_dqoi.sendMessage(null);
                    this.dqoiPopup(msg.value, SearchTarget.dispatch);
                }
                else if (msg.messageType === MessageType.refresh) {
                    if (this.searchTarget === msg.value || ((this.searchTarget && msg.searchTarget) === msg.searchTarget && this.dqoiIndex === msg.dqoiIndex)) {
                        this.refreshDQOI();
                    }
                }
                else if (msg.messageType === MessageType.hotKeyOn) {
                    //this.setKeyListener(true);
                }
                else if (msg.messageType === MessageType.hotKeyOff) {
                    //this.setKeyListener(false);
                }
            }
        });

        //this is a special case where we actually need to add subscriptions in the CTOR. This is due to no classes properly using override, so we have no context into if it should or shouldnt be overridden.
        this.subs_featureFlagSet = this.featureFlagService.featureFlagSets.subscribe(data => {
            this.internalFeatureFlagSet = data;
        });

        validateOverridables(this, Object.getPrototypeOf(this).constructor.name, BaseDQOIComponent);
    }

    @EmptyOverridable()
    public setupCheckFormLocal() { }

    @EmptyOverridable()
    customReferenceData() { }

    @EmptyOverridable()
    onTabSelect(e: SelectEvent) { }

    @EmptyOverridable()
    customCustomerChanged() { }

    @EmptyOverridable()
    checkCustomerChangeValid() { }

    @EmptyOverridable()
    setValidators() { }

    @EmptyOverridable()
    getCustomerLocationPriceRanges(id: any) { }

    @EmptyOverridable()
    setRequiredFileds() { }

    @EmptyOverridable()
    setLocationDefaultsOther(data: v_LocationDetailBus) { }

    @EmptyOverridable()
    protected setNoData(item: DQOIItem) { }

    @EmptyOverridable()
    getDataFromNumber(no: string) { }

    @EmptyOverridable()
    getAddtlData() { }

    @EmptyOverridable()
    afterDataSet() { }

    @EmptyOverridable()
    setMasterId() { }

    @EmptyOverridable()
    afterSetForm() { }

    @EmptyOverridable()
    setDQOIState() { }

    @EmptyOverridable()
    setForm() { }

    @EmptyOverridable()
    setFormLocation(data: any) { }

    @EmptyOverridable()
    clearChildren() { }

    @EmptyOverridable()
    delete() { }

    @EmptyOverridable()
    saveIndividual() { }

    @EmptyOverridable()
    saveAll() { }

    @EmptyOverridable()
    panelExpand(e: any) { }

    /**
    * @deprecated This customParentMessage is deprecated and will be removed in future versions. Deprecated on: 05.20.2025. Override parentMessage instead.
    */
    @EmptyOverridable()
    customParentMessage(e: Message) { }

    @EmptyOverridable()
    refreshDQOI(token: RefreshToken = null) { }

    @EmptyOverridable()
    getListFromMaster(refresh: boolean = false) { }

    @EmptyOverridable()
    confirmCustom(data: ConfirmOutput) { }

    @EmptyOverridable()
    print(checkSave: boolean = true) { }

    subs_keyPress: Subscription;
    protected static checkingReferenceDate: boolean = false;
    @ViewChild('locationGeoInfoComp') protected locGeoInfoComp: GeographyInfoComponent;
    @ViewChild('billToGeoInfoComp') protected billToGeoInfoComp: GeographyInfoComponent;
    @ViewChild('shippingGeoInfoComp') protected shippingGeoInfoComp: GeographyInfoComponent;
    @ViewChild('cnfDialog') protected cnfDialog: ConfirmDialogComponent;
    @ViewChild('miDialog') protected miDialog: MessageInfoDialogComponent;
    @ViewChild('afterHoursPODialog') protected afterHoursPODialog: AfterHoursPoComponent;
    @ViewChild("customerSel") customerSel: ComboBoxComponent;
    @ViewChild("mainTab") mainTab: TabStripComponent;
    @ViewChild("subTab") subTab: TabStripComponent;
    @ViewChild("ddlMasterList") ddlMasterList: DropDownListComponent;

    @Input() DQOIInput: DQOIItem;
    @Input() isConstruction: boolean = false;
    @Input() isBidSheetAdmin: boolean = false;
    @Input() isSelected: boolean = false;
    @Input() searchOperatingMode: number = 1; //2-Multiple searches
    @Input() appOperationCode: number = AppOperationCode.DQOI;
    dqoiIndex: number = null;
    ngAfterViewInit() {
        if (this.setFocus) {
            this.setFocus = false;
            this.setDefaultFocus();
        }
        this.getCommon();
    }
    locationDetailClass: string = "v_LocationDetailBus";
    locationDetail: v_LocationDetailBus;
    searchTarget: SearchTarget = SearchTarget.any;
    editForm: UntypedFormGroup;
    qry_rd: DQOIReferenceDataQuery;
    svc_dqoi: DQOIService;
    lockEdit: boolean = false;
    data: T;
    originalData: T;
    addtlData: A;
    addtlDataClass: string;
    svc_data: S;
    pageData: P;
    public static _referenceData: DQOIReferenceData;
    get referenceData(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }
    get isActive(): boolean {
        return true;
    }
    refreshToken: any;
    id: any;
    protected _masterId: any;
    subs_save: Subscription;
    subs_delete: Subscription;
    subs_dataAddInfo: Subscription;
    subs_geographyAddressBillTo: Subscription;
    subs_geographyAddressShipTo: Subscription;
    subs_masterList: Subscription;
    subs_print: Subscription;
    subs_locationDefaults: Subscription;
    subs_dataSearchEvent: Subscription;
    subs_toolbarEvent: Subscription;
    subs_dataNewConstruction: Subscription;
    readOnly: boolean = true;
    formValid: boolean = true;
    customerLocations: GItem[] = null;
    customerGeoLocations: GItem[] = null;
    settingFromDQOIState: boolean = false;
    billToGeoInfo: GeographyInfoBus = new GeographyInfoBus();
    locationGeoInfo: GeographyInfoBus = new GeographyInfoBus();
    shippingGeoInfo: GeographyInfoBus = new GeographyInfoBus();
    addtlDataLoader: boolean = false;
    afterSaveAction: any = CommonActions.None;
    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };
    canEditValue: boolean = true;
    childCanEditValue: boolean = true;
    formIsDirty: boolean = false;
    hasIdValue: boolean = false;
    canSaveValue: boolean = false;
    public setupCheckForm() {
        this.editForm.statusChanges.subscribe(val => {
            this.formValid = (val == "VALID");
            this.childCanEditValue = this.childCanEdit;
            this.canEditValue = this.canEdit;
            this.formIsDirty = this.editForm.dirty;
            this.canSaveValue = this.canSave && this.canEditValue;
            this.setupCheckFormLocal();

        });
        this.editForm.valueChanges.subscribe(val => {
            this.childCanEditValue = this.childCanEdit;
            this.canEditValue = this.canEdit;
            this.formIsDirty = this.editForm.dirty;
            this.canSaveValue = this.canSave && this.canEditValue;
            this.setupCheckFormLocal();
        });
    }
    public navigate(url: string) {
        setTimeout(() => {
            window.open(url, "_blank");
        });
    }

    @Output() dqoiMessage: EventEmitter<DQOIMessage> = new EventEmitter<DQOIMessage>();
    customer: string;
    location: string;
    saveMode: any = SaveMode.individual;
    protected _saveModeAfterId: any = SaveMode.individual;
    get saveModeAfterId(): any {
        return this.hasId && !this.isAdded ? this._saveModeAfterId : this.saveMode;
    }
    get isAdded(): boolean {
        return this.hasData ? this.data.isAdded : true;
    }
    get serviceMode(): any {
        return !this.hasReferenceData || this.rights.FG2RegularAccess === true || this.isConstruction === true ? "0" : this.referenceData.serviceMode;
    }
    saveOnly: boolean = false; //so that if save needs to be called from some other function and are leaving the page
    set: boolean = false;
    get hasReferenceData(): boolean {
        let retVal: boolean = false;
        try {
            retVal = this.referenceData !== undefined && this.referenceData !== null && CommonFunctions.hasArrayElementValue(this.referenceData.dispatchStatus) ? true : false;
        }
        catch {
            retVal = false;
        }
        return retVal;

    }
    get hasLocationDetail(): boolean {
        return CommonFunctions.hasValue(this.locationDetail);
    }
    protected holdCusLocDefaults: boolean = false;
    pDataArr: GItem[];
    newParam: CommonParam;
    callTrySave: boolean = false;

    setDefaultFocus() {
        if (!this.hasId && CommonFunctions.hasValue(this.customerSel)) {
            setTimeout(() => {
                this.customerSel.focus();
            });

        }
    }
    callCurrentTab() {
        if (this.mainTab && this.mainTab.tabs) {
            let currTab: TabStripTabComponent = this.mainTab.tabs.find(s => s.selected === true);
            if (currTab) {
                let e: SelectEvent = new SelectEvent(0, currTab.title);
                //e.title = this.mainTab.tabs[i].title;
                this.onTabSelect(e);
            }
        }
        if (this.subTab && this.subTab.tabs) {
            let currTab: TabStripTabComponent = this.subTab.tabs.find(s => s.selected === true);
            if (currTab) {
                let e: SelectEvent = new SelectEvent(0, currTab.title);
                //e.title = this.mainTab.tabs[i].title;
                this.onTabSelect(e);
            }
        }
    }
    @Input() common: CommonParam;
    protected get hasCommon(): boolean {
        return CommonFunctions.hasValue(this.common);
    }
    protected getCommon(): CommonParam {
        if (!this.hasCommon) {
            this.common = new CommonParam();
        }
        return this.common;
    }

    get hasEditForm(): boolean {
        return this.editForm !== undefined && this.editForm !== null ? true : false;
    }
    get hasData(): boolean {
        return this.data !== undefined && this.data !== null;
    }
    get hasAddtlData(): boolean {
        return CommonFunctions.hasValue(this.addtlData);
    }
    get canEdit(): boolean {
        return this.hasData && this.appSaveValidation() && !this.lockEdit;
    }
    get canAdd(): boolean {
        return this.serviceMode !== "1" && this.appOperationCode !== AppOperationCode.OrderSearch;
    }
    get childCanEdit(): boolean {
        return this.canEdit && this.isValid && this.serviceMode !== "1" && ((this.saveMode == SaveMode.individual || !this.readOnly));
    }
    get canClear(): boolean {
        return this.readOnly && this.hasData;
    }
    get isDirty(): boolean {
        return !this.readOnly && this.hasEditForm && this.editForm.dirty;
    }
    get customAppSaveValidation(): boolean {
        return true;
    }
    appSaveValidation(): boolean {
        let canSave = true;
        if (!this.isConstruction && this.serviceMode === "1" && (this.searchTarget !== SearchTarget.dispatch || (this.searchTarget === SearchTarget.dispatch && !this.customAppSaveValidation))) {
            canSave = false;
        }
        return canSave;
    }

    private _canSaveValue: boolean = false;
    private updateCanSaveValue(): void {
        let okToSave: boolean = false;
        if (this.isDirty) {
            if (this.hasId) {
                okToSave = this.formValid && this.customFormValidation() && this.appSaveValidation();
            }
            else {
                okToSave = this.formValid && this.customFormValidation() && this.appSaveValidation();
            }
        }
        okToSave = okToSave && !this.anyLoadingsOn && !this.lockEdit;
        this._canSaveValue = okToSave || this._hasSaveError;
    }

    get canSave(): boolean {
        this.updateCanSaveValue();
        return this._canSaveValue;
    }

    /**
     * This is a property that is used to determine if the save operation has encountered an error.
     * This will control if the setPristine() method is called after the save operation.
     *
     * @protected
     * @type {boolean}
     * @memberof BaseAppMComponent
     */
    protected set hasSaveError(value: boolean) {
        if (this._hasSaveError !== value) {
            this._hasSaveError = value;
            this.updateCanSaveValue();
        }
    }
    private _hasSaveError: boolean = false;


    get anyLoadingsOn(): boolean {
        return this.mainDataLoading || this.addtlDataLoader;
    }
    get isValid(): boolean {
        let isValid: boolean = false;
        if (this.hasId) {
            isValid = this.formValid && this.customFormValidation() && this.appSaveValidation();
        }
        else {
            isValid = this.formValid && this.customFormValidation() && this.appSaveValidation();
        }
        isValid = isValid && !this.mainDataLoading && !this.addtlDataLoader;

        return isValid;
    }
    get canPrint(): boolean {
        return this.hasId && !this.canSave && !this.mainDataLoading && !this.addtlDataLoader;
    }
    get canImport(): boolean {
        var okToImport = this.formValid && this.customFormValidation();
        return okToImport;
    }
    setDirty() {
        if (this.hasEditForm) {
            this.editForm.markAsDirty();
            this.formIsDirty = this.editForm.dirty;
        }
        this.setFormFlags();
    }
    setPristine() {
        if (this.hasEditForm) {
            this.editForm.markAsPristine();
        }
        this.setFormFlags();
    }
    get customerId(): any {
        return this.hasEditForm ? this.editForm.value.customerId : null;
    }
    get locationId(): any {
        return this.hasEditForm && CommonFunctions.hasValue(this.editForm.value) ? this.editForm.value.locationId : this.getLocationIdFromData();
    }

    get hasCustomer(): boolean {
        return CommonFunctions.hasValue(this.customerId);
    }
    get hasLocation(): boolean {
        return CommonFunctions.hasValue(this.locationId);
    }
    get hasCustomerLocation(): boolean {
        return this.hasCustomer && this.hasLocation;
    }
    getLocationIdFromData(): any {
        let locId = null;
        if (this.hasData) {
            locId = this.data["locationId"];
        }
        return locId;
    }
    hasIdCounter = 0;
    get hasId(): boolean {
        return this.hasData && (this.data.hasId && !this.data.isAdded) ? true : false;
    }
    get primaryNumber(): string {
        return "";
    }
    get hasPrimaryNumber(): boolean {
        return CommonFunctions.hasStringValue(this.primaryNumber);
    }
    get masterId(): any {
        return this._masterId;
    }
    get hasMasterId(): boolean {
        return CommonFunctions.hasValue(this.masterId);
    }
    get dataObjOrEditObj(): any {
        if (this.readOnly) {
            return this.data;
        }
        else {
            return this.editForm.value;
        }
    }
    customFormValidation() {
        return true;
    }
    customerCBOChanged(item: any) {
        if (CommonFunctions.hasValue(item)) {
            this.customerChanged(item.value);
        }
        else {
            this.customerChanged(null);
        }
    }
    sendDQOIMessage(customer: string, location: string) {
        let message: DQOIMessage = new DQOIMessage();
        message.customer = customer;
        message.location = location;
        message.customerId = this.customerId;
        message.locationId = this.locationId;
        message.messageType = MessageType.customerAndLocation;
        this.dqoiMessage.emit(message);
    }
    sendParentMessage(message: DQOIMessage) {
        this.dqoiMessage.emit(message);
    }
    sendRefreshMessage(target: SearchTarget, appCategory: AppCategory) {
        let message: Message = new Message();
        message.messageType = MessageType.refresh;
        //if(!this.hasCustomer)
        message.searchTarget = target;
        message.dqoiIndex = this.dqoiIndex;
        let token: RefreshToken = new RefreshToken();
        token.messageType = MessageType.refresh;
        token.target = target;
        token.appCategory = appCategory;
        message.value = token;

        this.svc_dqoi.sendMessage(message);
    }
    goTo(data: any, target: SearchTarget, code: string = "GOTO") {
        let param: DQOIParam = new DQOIParam();
        param.dqoiItem = this.svc_dqoi.getDQOIItem(this.dqoiIndex);
        param.target = target;
        param.id = data;
        param.data = data;
        param.code = code;
        let message: DQOIMessage = new DQOIMessage();
        message.messageData = param;
        message.messageType = code === "GOTONEWDQOI" ? MessageType.goToNewDQOI : MessageType.goTo;

        this.sendParentMessage(message);
    }
    mainLoadingOn(disableAll: boolean = false, cpLoader: ICPLoader = null) {
        this.mainDataLoading = true;
        if (cpLoader) {
            cpLoader.cpLoaderOn();
        }
        if (disableAll) {
            let message: DQOIMessage = new DQOIMessage();
            let param: CommonParam = new CommonParam();
            param.addParam("FromTarget", this.searchTarget);
            message.messageType = MessageType.disableMainTabs;
            this.sendParentMessage(message);
        }
    }
    mainLoadingOff(enableAll: boolean = false, cpLoader: ICPLoader = null) {
        this.mainDataLoading = false;
        if (cpLoader) {
            cpLoader.cpLoaderOff();
        }

        if (enableAll) {
            let message: DQOIMessage = new DQOIMessage();
            let param: CommonParam = new CommonParam();
            param.addParam("FromTarget", this.searchTarget);
            message.messageType = MessageType.enableMainTabs;
            this.sendParentMessage(message);
        }
    }
    mainDataLoading: boolean = false;
    get disableTabs(): boolean {
        return this.mainDataLoading;
    }
    dqoiLoader(state: boolean) {
        let message: DQOIMessage = new DQOIMessage();
        message.messageType = state ? MessageType.miniLoaderOn : MessageType.miniLoaderOff;
        this.sendParentMessage(message);
    }
    reqWO: boolean = false;
    customerReqWO: boolean = false;
    customerChanged(id: any, holdLocationChange: boolean = false) {
        this.location = null;
        let custId: any = id;
        if (CommonFunctions.hasValue(this.referenceData) && CommonFunctions.hasArrayValue(this.referenceData.locations) && CommonFunctions.hasValue(id)) {
            this.customer = this.referenceData.getCustomerDesc(id); // .customers.find(s => s.value === id).description;
            this.customerLocations = this.referenceData.locations.filter(e => e.category === id);
            this.customerGeoLocations = this.referenceData.locations.filter(e => e.category === id);
        }
        else {
            this.customer = null;
            //  this.editForm.value.customerId = null;
            this.customerLocations = [];
            this.customerGeoLocations = [];
        }
        this.editForm.patchValue({
            customerId: custId,
            locationId: null
        });
        if (!holdLocationChange) {
            this.locationChanged(null);
        }

        this.reqWO = false;
        if (CommonFunctions.hasGuidValue(id) && this.hasReferenceData) {
            this.reqWO = this.referenceData.getCustomerDCValue(id, "ReqWO");
            this.customerReqWO = this.reqWO;
        }
        this.customCustomerChanged();
        this.checkCustomerChangeValid();
    }

    locationCBOChanged(item: GItem) {
        if (CommonFunctions.hasValue(item)) {
            this.locationChanged(item.value);
        }
        else {
            this.locationChanged(null);
        }
    }
    public locCBOFilterChange(filter: any): void {
        this.customerLocations = this.referenceData.locations.filter((s) => s.category === this.customerId && s.description.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
    }

    locationChanged(id: any) {
        if (CommonFunctions.hasValue(id)) {
            this.location = this.referenceData.getLocationDesc(id); // locations.find(s => s.value == id).description;
            this.getLocationDefaults(id);
            this.getCustomerLocationPriceRanges(id);
            this.editForm.patchValue({
                locationId: id
            });
        }
        else {
            this.editForm.patchValue({
                locationId: null
            });
            this.location = null;
            let locGeoInfo: GeographyInfoBus = new GeographyInfoBus();
            this.setLocationGeoInfo(locGeoInfo);
            this.setBillToGeoInfo(locGeoInfo);
            if (CommonFunctions.hasStringValue(this.locationDetailClass)) {
                let locDetail = BusinessObjectFactory.Create(this.locationDetailClass);
                this.setFormLocation(locDetail);
            }
        }
        this.sendDQOIMessage(this.customer, this.location);
    }

    getLocationDefaults(id: any) {
        this.svc_dqoi.getLocationDetailAsDefaults(id).subscribe((data: v_LocationDetailBus) => {
            let locGeoInfo: GeographyInfoBus = new GeographyInfoBus();
            locGeoInfo.set(data.geographyId, data.locationName, data.addressLine1, data.addressLine2, data.city, data.stateProvince, data.countryCd, data.county, data.postalCode);
            let billToGeoInfo: GeographyInfoBus = new GeographyInfoBus();
            billToGeoInfo.set(data.billingGeographyId, data.billingAddressName, data.billingAddressLine1, data.billingAddressLine2, data.billingCity, data.billingStateProvince, data.countryCd, data.billingCounty, data.billingPostalCode);

            this.setLocationGeoInfo(locGeoInfo);
            this.setBillToGeoInfo(billToGeoInfo);
            this.setShippingGeoInfo(locGeoInfo);
            if (!this.holdCusLocDefaults) {
                this.setFormLocation(data);
            }
            this.locationDetail = new v_LocationDetailBus(data);
            this.setRequiredFileds();
            this.setLocationDefaultsOther(data);
            this.holdCusLocDefaults = false;

            if (CommonFunctions.hasGuidValue(id) && !this.customerReqWO) {
                this.reqWO = this.locationDetail.reqWorkNum;
                this.setValidators();
            }
        });
    }
    get sageCust(): string {
        return "Oracle Customer Id " + (this.hasLocationDetail ? this.locationDetail.sageCust : "");
    }
    get fullContract(): boolean {
        let isFullContract: boolean = false;
        if (this.hasLocationDetail) {
            isFullContract = this.locationDetail.fullContract;
        }
        else if (this.hasReferenceData && this.hasLocation) {
            let loc: GCItem = this.referenceData.getLocation(this.locationId);
            if (loc) {
                isFullContract = loc.fullContract;
            }
        }
        else if (this.hasReferenceData && this.hasData) {
            let dataLocationId = this.data["locationId"];
            let loc: GCItem = this.referenceData.getLocation(dataLocationId);
            if (loc) {
                isFullContract = loc.fullContract;
            }
        }
        return isFullContract;
    }

    public checkChange(dqoiIndex: number, target: SearchTarget, clear: boolean = false) {
        let item: DQOIItem = new DQOIItem(this.svc_dqoi.getDQOIItem(dqoiIndex));
        if (clear) {
            this.internalFeatureFlagSet["construction-add-new-change-order"] ? this.setNoData(item) : this.resetData(null);
            return;
        }
        if (!CommonFunctions.hasValue(this.dqoiIndex)) {
            this.setDQOIIndex(dqoiIndex);
        }
        switch (target) {
            case SearchTarget.dispatch:
                if (item.hasDispatchId && item.dispatchId !== this.id) {
                    this.resetData(item);
                }
                break;
            case SearchTarget.quote:
                if (item.hasQuoteId) {
                    if (item.quoteId !== this.id) {
                        this.resetData(item);
                    }
                }
                else if (item.hasDispatchId) {
                    this.setNoData(item);
                }
                break;
            case SearchTarget.order:
                if (this.hasData && this.data.isAdded) {
                    this.setForm();
                }
                else if (item.hasOrderId) {
                    if (item.orderId != this.id) {
                        this.resetData(item);
                    }
                }
                else if (item.hasDispatchId) {
                    this.setNoData(item);
                }
                break;
            case SearchTarget.invoice:
                if (this.hasData && this.data.isAdded) {
                    if (!this.isDirty) {
                        this.setForm();
                    }
                }
                else if (item.hasInvoiceId) {
                    if (item.invoiceId !== this.id) {
                        this.resetData(item);
                    }
                }
                else if (item.hasDispatchId) {
                    this.setNoData(item);
                }
                break;
            case SearchTarget.contract:
                if (item.hasContract && item.contractId) {
                    if (item.contractId !== this.id) {
                        this.resetData(item);
                        //this.setNoData(item);
                    }
                }
                break;
            case SearchTarget.job:
                if (item.hasJob) {
                    if (item.jobId !== this.id) {
                        this.resetData(item);
                        //this.setNoData(item);
                    }
                }
                else if (item.hasDispatchId) {
                    this.setNoData(item);
                }
                break;
        }
    }
    dataItemSelected(data: any) {
        this.clear();
        this.getDataFromId(data.value);
        if (this.ddlMasterList) {
            this.ddlMasterList.reset();
        }
    }

    protected resetData(dqoiItem: DQOIItem, callNew: boolean = false) {
        this.settingFromDQOIState = true;
        if (callNew) {
            this.new();
        }
        else {
            this.clear();
        }

    }
    setDQOIIndex(index: any) {
        this.dqoiIndex = index;
    }
    private subs_featureFlagSet: Subscription;
    private internalFeatureFlagSet: {};
    unsubscribe_init() {
        CommonFunctions.unsubscribe(this.subs_toolbarEvent);
        CommonFunctions.unsubscribe(this.subs_dataSearchEvent);
    }
    ngOnDestroy() {
        this.clear();
        this.unsubscribe_init();
        CommonFunctions.unsubscribe(this.subs_dataAddInfo);
        CommonFunctions.unsubscribe(this.subs_save);
        CommonFunctions.unsubscribe(this.subs_print);
        CommonFunctions.unsubscribe(this.subs_masterList);
        CommonFunctions.unsubscribe(this.subs_geographyAddressBillTo);
        CommonFunctions.unsubscribe(this.subs_geographyAddressShipTo);
        CommonFunctions.unsubscribe(this.subs_keyPress);
        CommonFunctions.unsubscribe(this.subs_featureFlagSet);
    }

    ngOnInit() {
        CommonFunctions.unsubscribe(this.subs_dataSearchEvent);
        this.subs_dataSearchEvent = this.svc_dqoi.searchEvent$.subscribe((data: DQOISearchEvent) => {
            if (this.searchOperatingMode === SearchOperatingMode.Single) {
                if (CommonFunctions.getBoolValueIfNull(this.hasData) || CommonFunctions.getBoolValueIfNull(this.set)) {
                    return;
                }
                this.set = true;
            }
            //let item: DQOIItem = this.svc_dqoi.getDQOITem()
            if (data !== null && data.searchTarget === this.searchTarget) {
                this.dqoiIndex = data.dqoiItem.index;
                if (data.isNew === undefined || data.isNew === null || data.isNew === false) {
                    this.referenceData.customerLocationAddIfInactive(data.dqoiItem.customerId, data.dqoiItem.locationId);

                    switch (this.searchTarget) {
                        case SearchTarget.dispatch:
                            this.id = data.dispatchId;
                            //this.id = data.id;
                            this.getData();
                            break;
                        case SearchTarget.invoice:
                            //this.getDataFromNumber(data.invoiceNumber);
                            if (!data.dqoiItem.id) {
                                this.id = data.dqoiItem.invoiceId;
                            } else {
                                this.id = data.dqoiItem.id;
                            }
                            this.getDataFromId(this.id);
                            break;
                        case SearchTarget.quote:
                            //this.getDataFromNumber(data.quoteNumber);
                            if (!data.dqoiItem.id) {
                                this.id = data.dqoiItem.quoteId;
                            } else {
                                this.id = data.dqoiItem.id;
                            }
                            this.getDataFromId(this.id);
                            break;
                        case SearchTarget.order:
                            this.id = data.dqoiItem.orderId;
                            this.getDataFromId(this.id);
                            break;
                        case SearchTarget.contract:
                            this.id = data.dispatchId;
                            //this.id = data.id;
                            this.getData();
                            break;
                        case SearchTarget.job:
                            this.id = data.dqoiItem.hasJobId ? data.dqoiItem.jobId : data.dispatchId;
                            //this.id = data.id;
                            this.getData();
                            break;
                    }
                }
                else {
                    this.new();
                }
            }
        });
        CommonFunctions.unsubscribe(this.subs_toolbarEvent);
        this.subs_toolbarEvent = this.svc_dqoi.toolbarEvent$.subscribe((data: DQOIToolbarEvent) => {
            if (data !== null && data.searchTarget === this.searchTarget) {
                switch (data.toolbarEvent) {
                    case ToolbarEvent.edit:
                        this.edit();
                        break;
                    case ToolbarEvent.save:
                        this.save();
                        break;
                    case ToolbarEvent.cancel:
                        this.cancel();
                        break;
                    case ToolbarEvent.clear:
                        this.clear();
                        break;
                    case ToolbarEvent.new:
                        this.new();
                        break;
                    case ToolbarEvent.checkChange:
                        this.checkChange(data.index, data.searchTarget);
                        break;
                }
            }
        });
    }

    getDataFromId(id: any) {
        this.id = id;
        this.getData();
    }
    unsubscribe_getData() {
        CommonFunctions.unsubscribe(this.subs_data);
        CommonFunctions.unsubscribe(this.subs_dataAddInfo);
        CommonFunctions.unsubscribe(this.subs_dataNewConstruction);
    }

    getData() {
        this.getAddtlData();
    }

    setFormFlags() {
        if (this.hasEditForm) {
            this.formValid = this.editForm.valid;
            this.formIsDirty = this.editForm.dirty;
        }
        this.childCanEditValue = this.childCanEdit;
        this.canEditValue = this.canEdit;
        this.canSaveValue = this.canSave && this.canEditValue;

        this.setupCheckFormLocal();
    }

    callMainLoaderOffAfterSetData: boolean = false;
    setDataCompLoader: ICPLoader = null;
    setData(data: T) {
        this.data = this.createNew(data);
        this.hasIdValue = this.hasId;
        this.originalData = _.cloneDeep(data);
        this.afterDataSet();
        this.setMasterId();
        if (this.hasMasterId && (!this.hasMasterList || this.resetMasterList)) {
            this.resetMasterList = false;
            this.getListFromMaster();
        }
        this.setForm();
        this.afterSetForm();
        this.setDQOIState();
        this.setDQOIDisplay();
        this.callCurrentTab();
        this.dqoiLoader(false);
        this.setPristine();
        if (this.callMainLoaderOffAfterSetData) {
            this.callMainLoaderOffAfterSetData = false;
            this.mainLoadingOff(true, this.setDataCompLoader);
        }
    }
    setDQOIDisplay() {
        if (this.hasCustomer && this.hasLocation && this.hasReferenceData) {
            this.customer = this.referenceData.getCustomerDesc(this.customerId); // .customers.find(s => s.value == this.customerId).description;
            this.location = this.referenceData.getLocationDesc(this.locationId); // .locations.find(s => s.value == this.locationId).description;

            this.sendDQOIMessage(this.customer, this.location);
        }

    }
    get accountClasses(): GGItem[] {
        let classes: GGItem[] = [];

        if (this.hasReferenceData) {
            if (this.internalFeatureFlagSet['allow-service-classes-on-warranty-job-types']) {
                var dqoiitem = this.svc_dqoi.getDQOIItem(this.dqoiIndex);
                if (dqoiitem != null) {
                    if ((dqoiitem.dispatchStatusId == CommonValues.Dispatch_ForConstructionReview)
                        && this.isConstruction && dqoiitem.relatedJobTypeId == null && dqoiitem.masterJobId != null) {
                        classes = this.referenceData.accountClasses;
                    } else {
                        classes = this.isConstruction ? this.referenceData.accountClassesConstruction : this.referenceData.accountClassesService;
                    }
                } else {
                    classes = this.isConstruction ? this.referenceData.accountClassesConstruction : this.referenceData.accountClassesService;
                }
            }
            else {
                classes = this.isConstruction ? this.referenceData.accountClassesConstruction : this.referenceData.accountClassesService;
            }
        }
        return classes;
    }
    refreshDQOIItem(id: any) {
        let msg: DQOIMessage = new DQOIMessage();
        msg.messageType = MessageType.getDQOIItem;
        let token: RefreshToken = new RefreshToken();
        token.id = id;
        token.target = this.searchTarget;
        token.dqoiIndex = this.dqoiIndex;
        msg.messageData = token;
        this.sendParentMessage(msg);
    }

    createNewAdditionalData(): A {
        let busObj: A = BusinessObjectFactory.Create(this.addtlDataClass, null);
        busObj.initialize(null);
        return busObj;
    }
    setNewDefaults() {
        this.data.setNew(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId, this.id, this.isConstruction);
        this.data.isAdded = true;
        this.addtlData = this.createNewAdditionalData();
        this.setDefaultCustomerLocation();
    }
    setCustomerLocation(customerId: any, locationId: any) {
        if (CommonFunctions.hasGuidValue(customerId)) {
            this.customerChanged(customerId, true);
            if (CommonFunctions.hasGuidValue(locationId)) {
                this.locationChanged(locationId);
            }
        }
    }

    setDefaultCustomerLocation() {
        var dqoiitem = this.svc_dqoi.getDQOIItem(this.dqoiIndex);

        if (dqoiitem != null && dqoiitem.hasCustomerId && dqoiitem.hasLocationId) {
            this.setCustomerLocation(dqoiitem.customerId, dqoiitem.locationId);
        }
    }
    new() {
        this.setFocus = true;
        this.clear();
        this.setNewDefaults();
        this.setData(this.data);
        this.edit();
        //this.setDefaultFocus();
        this.clone();
        this.setDirty();
        this.dqoiLoader(false);
    }
    clone() {
        this.originalData = _.cloneDeep(this.data);
    }
    setFocus: boolean = false;
    edit() {
        if (this.serviceMode === "0") {
            this.readOnly = false;
        }
    }
    editOff() {
        if (!this.rights.DefaultEditMode || this.serviceMode === "1") {
            this.readOnly = true;
        }
    }
    createNew(busObj: T): T {
        let obj = {} as T;
        if (obj.initialize) {
            obj.initialize(busObj);
        }
        return obj;
    }

    cancel() {
        let data = this.createNew(this.originalData);
        if (!this.data.hasId) {
            let tempOriginalData = _.cloneDeep(this.originalData);
            this.clear();
            this.originalData = _.cloneDeep(tempOriginalData);
            this.customerLocations = [];
            this.customerGeoLocations = [];
            this.setDirty();
        }
        this.id = this.data.CID();
        this.data = data;
        this.afterDataSet();
        this.setForm();
        this.setPristine();
        this.editOff();
        this.cancelChildren();
        this.refreshData(null);

    }
    protected cancelChildren() {
        this.pageData.clear();
        this.getAddtlData();
    }

    expandFromMinData() {
        this.refreshData(null);
    }
    clear() {
        this.data = this.createNew(null);
        this.originalData = this.createNew(null);
        this.id = null;
        this.customerLocations = [];
        this.customerGeoLocations = [];
        this.readOnly = true;
        try {
            this.editForm.reset();
        }
        catch (e) {

        }
        if (CommonFunctions.hasValue(this.pageData)) {
            this.pageData.clear();
        }
        this.clearAddtlData();
        if (this.rights.DefaultEditMode && this.serviceMode === "0") {
            this.edit();
        }
        this.clearChildren();
    }
    protected clearAddtlData() {
        if (CommonFunctions.hasValue(this.addtlData)) {
            this.addtlData.clear();
        }
    }

    close() {
        this.clear();
    }
    trySaveMsg(from: string, e: any = null, cpLoader: ICPLoader) {
        let date: Date = DateFunctions.getDateNow();
        if (e) {
            e.stopPropagation();
        }
        this.trySave(cpLoader);
    }
    trySave(cpLoader: ICPLoader) {
        var msgInfo = this.canSaveChildren();
        if (!msgInfo.warning) {
            this.save();
        }
        else {
            this.isSaving = false;
            this.mainLoadingOff(true, cpLoader);
            this.miShow("Please Address the following issue(s) before saving:", msgInfo, "Cannot Save Message");
        }
    }
    isSaving: boolean = false;
    save() {
        this.setForSave();
        if (this.saveMode === SaveMode.individual) {
            this.saveIndividual();
        }
        else {
            this.saveAll();
        }
        this.setPristine();
    }

    get canDelete(): boolean {
        return true;
    }

    setForSave(): T {
        return null;
    }
    get canEditInFinance(): boolean {
        return !this.readOnly && (!(this.inFinance === true) || (this.rights.FinancialLockOverride)); //(false) => some other right
    }
    get inFinance(): boolean {
        return this.hasData ? this.data.inFinance : false;
    }

    protected saveSuccess(message: string = null) {
        let not: string = this.appCode + " Successfully Saved" + (CommonFunctions.hasStringValue(message) ? " " + message : "");
        this.globals.notifySuccess(not);
        this.editOff();
        this.checkAfterSaveAction();
    }
    protected saveError(message: string = null) {
        let not: string = "There was a problem saving " + this.appCode + ": " + (CommonFunctions.hasStringValue(message) ? " " + message : "");
        this.globals.notifyError(not, true);
    }
    protected notifyError(message: string = null) {
        let not: string = "There was a problem " + (CommonFunctions.hasStringValue(message) ? " " + message : "");
        this.globals.notifyError(not, true);
    }

    protected deleteSuccess() {
        this.globals.notifySuccess(this.appCode + " Deleted Successfully!");
        this.refreshDQOIItem(null);
    }
    protected deleteError(message: string) {
        this.globals.notifyError("Delete Encountered an Error: " + message, true);
    }

    refresh(matExpansionPanel: MatExpansionPanel, event: Event, code: string) {
        event.stopPropagation();
        this.panelExpand(code);
    }
    validBillToGeoInfoGeographyId() {
        if (this.billToGeoInfo.geographyId) return true;
        return false;
    }
    setBillToGeoInfo(data: GeographyInfoBus) {
        this.billToGeoInfo = new GeographyInfoBus(data);
    }
    setLocationGeoInfo(data: GeographyInfoBus) {
        this.locationGeoInfo = new GeographyInfoBus(data);
    }
    setShippingGeoInfo(data: GeographyInfoBus) {
        this.shippingGeoInfo = new GeographyInfoBus(data);
    }
    clearShippingGeoInfo() {
        this.shippingGeoInfo = new GeographyInfoBus();
    }
    get locState(): string {
        return CommonFunctions.hasValue(this.locationGeoInfo) ? this.locationGeoInfo.stateProvince : "";
    }
    afterSaveMessage: Message;
    setAfterSaveMessage(msg: Message) {
        this.afterSaveMessage = msg;
    }

    setHotKey(state: boolean) {
        let msg: Message = new Message();
        msg.searchTarget = SearchTarget.appRoot;
        msg.messageType = state === true ? MessageType.hotKeyOn : MessageType.hotKeyOff;
        this.globals.sendMessage(msg);
    }
    parentMessage(e: Message, cpLoader: ICPLoader) {
        if (e.messageType === MessageType.saveParent) {
            if (!this.isSaving) {
                if (this.callTrySave) {
                    this.trySaveMsg("PM", null, cpLoader);
                }
                else {
                    this.save();
                }
            }
        }
        else if (e.messageType === MessageType.changed) {
            if (this.saveMode === SaveMode.all) {
                this.setDirty();
            }
        }
        else if (e.messageType === MessageType.refresh) {
            this.refreshData(e.refreshTarget);
        }
        else if (e.messageType === MessageType.createOrderFromParts) {
            let message: DQOIMessage = new DQOIMessage();
            message.messageData = e.values;
            message.messageType = MessageType.createOrderFromParts;
            if (!CommonFunctions.hasGuidValue(e.value)) { //e.value = parentId from Grid comp = dispatchId
                this.setAfterSaveMessage(e);
                this.save();
            }
            else {
                this.dqoiMessage.emit(message);
            }
        }
        else if (e.messageType === MessageType.createOrderFromJob) {
            let message: DQOIMessage = new DQOIMessage();
            message.messageData = e.value;
            message.messageType = MessageType.createOrderFromJob;
            this.dqoiMessage.emit(message);
        }
        else if (e.messageType === MessageType.goTo) {
            let message: DQOIMessage = new DQOIMessage();
            message.messageData = e.values;
            message.messageType = e.messageType;
            this.dqoiMessage.emit(message);
        }
        else if (e.messageType === MessageType.dqoiPopup) {
            let data: DispatchData = new DispatchData();
            data.viewDispatch.dispatchId = e.value;
            this.dqoiPopup(data, SearchTarget.dispatch);
        }
        else if (e.messageType === MessageType.messageInfo) {
            let info = new MessageInfoShow(e.values[0] as MessageInfoShow);
            this.miShow(info.message, info.messageInfo, info.data, info.title, info.code);
        }
        else if (e.messageType === MessageType.msgPopup) {
            this.cnfShowSomeGeneralMessage(e.message, e.messageSubject);
        }
        else if (e.messageType === MessageType.hotKeyOn) {
            // this.setKeyListener(true);
        }
        else if (e.messageType === MessageType.hotKeyOff) {
            //this.setKeyListener(false);
        }
        else if (e.messageType === MessageType.changedCM) {
            if (this.saveMode === SaveMode.all) {
                this.setDirty();
            }
            this.customParentMessage(e);
        }
        else {
            this.customParentMessage(e);
        }

    }
    showDQOIPopup(id: any, searchTarget: number) {
        let data: DispatchData = new DispatchData();
        data.viewDispatch.dispatchId = id;
        this.dqoiPopup(data, searchTarget);
    }

    refreshData(refreshTarget: DbTable) {
        if (!CommonFunctions.hasValue(refreshTarget)) {
            let index: number = -1;
            if (this.mainTab?.tabs) {
                this.mainTab.tabs.forEach((tab: TabStripTabComponent) => {
                    index++;
                    if (tab.selected === true) {
                        var event: SelectEvent = new SelectEvent(index, tab.title);
                        this.onTabSelect(event);
                    }
                });
            }
            this.svc_data.refresh();
        }
    }

    get hasMasterList(): boolean {
        return CommonFunctions.hasArrayElementValue(this.masterList);
    }
    resetMasterList: boolean = false;
    masterListLoader: boolean = false;
    masterList: any[];
    protected masterListAll: any[];
    cloneMasterList() {
        this.masterListAll = _.cloneDeep(this.masterList);
    }

    filterMasterList(value) {

        this.masterList = this.masterListAll.filter((s) => s.description.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }
    dqoiPopup(data: DispatchData, target: SearchTarget) {
        this.dqoiWindowData = data;
    }
    public dqoiWindowData: DispatchData;
    public cpActiveChildComp: number;
    public cpWindowData: any;
    public cpShowWindow: boolean = false;
    public cpContentTypes = WindowContents;
    cpPopWindow(injected: any) {
        this.cpActiveChildComp = injected.contentType;
        this.cpWindowData = injected.boardData;
        this.cpShowWindow = true;
    }
    onCPWindowClosed(e) {
        this.cpShowWindow = false;
    }

    canSaveChildren(): BaseMessageInfo {
        return new BaseMessageInfo();
    }
    deleteDialog(data: T) {
        this.cnfShow(CommonValues.Message_AreYouSureYouWantToDeleteThis, CRUDActions.Delete, data);
    }
    confirmDialog(data: ConfirmOutput) {
        let handled: boolean = false;
        if (data.dialogResult === CPDialogResult.ok) {
            switch (data.action) {
                case CRUDActions.Delete:
                    handled = true;
                    this.delete();
                    break;
            }
        }
        if (!handled) {
            this.confirmCustom(data);
        }
    }

    cnfShow(message: string, action: CRUDActions = CRUDActions.None, data: any = null, title: string = null, code: string = null, okButtonOnly = false, yesNo = false) {
        if (CommonFunctions.hasValue(this.cnfDialog)) {
            this.cnfDialog.show(message, action, data, title, code, okButtonOnly, yesNo);
        }
    }

    cnfShowSomeGeneralMessage(message: string, title: string = "") {
        this.cnfShow(message, CRUDActions.None, null, title, null, true);
    }
    cnfShowSomeGeneralMessages(messages: string[], title: string = "", width: number = null) {
        this.cnfDialog.showMessages(messages, title, width);
    }

    miShow(message: string, info: BaseMessageInfo, data: any = null, title: string = null, code: string = null, okButtonText: string = "Ok", type: MessageInfoType = MessageInfoType.general) {
        if (CommonFunctions.hasValue(this.miDialog)) {
            this.miDialog.show(message, info, data, title, code, okButtonText, type);
        }
    }

    checkAfterSaveAction() {
        if (this.afterSaveAction === CommonActions.Print) {
            this.afterSaveAction = CommonActions.None;
            this.print(false);
        }
    }

    setControlValue(fieldName: string, value: any, markAsDirty: boolean = true) {
        if (this.hasEditForm) {
            this.editForm.controls[fieldName].setValue(value);
            if (markAsDirty) {
                this.markControlDirty(fieldName);
            }
        }
    }
    markControlDirty(fieldName: string) {
        if (this.hasEditForm) {
            this.editForm.controls[fieldName].markAsDirty();
        }
    }
}

